import { Routes } from '@angular/router';
import { HomeComponent } from './shared/home/home.component';
import { ABOUTCOMPANY_ROUTES } from './modules/aboutcompany/aboutcompany-routing.module';
import { NEWSLETTER_ROUTES } from './modules/news-letters/news-letters-routing.module';
import { COMPANY_SERVICES_ROUTES } from './modules/company-services/company-services-routing.module';
import { INDUSTRIES_ROUTES } from './modules/industries/industries-routing.module';
import { BLOG_ROUTES } from './modules/blog/blog-routing.module';
import { caseStudiesRoutes } from './modules/case-studies/case-studies-routing.module';
import { whitepaper_routes } from './modules/whitepaper/whitepaper-routing.module';
import { techgeek_routes } from './modules/techgeek/techgeek-routing.module';
import { inthenews_routes } from './modules/in-the-news/in-the-news-routing.module';
import { Careers_Routes } from './modules/careers/careers-routing.module';
import { GalleryPage_Routes } from './modules/gallery-page/gallery-page-routing.module';
import { LEGAL_ROUTES } from './modules/aboutcompany/legal/legal-routing.module';

export const routes: Routes = [
    {path:'',component:HomeComponent},
    {path: 'aboutcompany', children: ABOUTCOMPANY_ROUTES},
    {path:'news-letters',children:NEWSLETTER_ROUTES},
    {path:'company-services',children:COMPANY_SERVICES_ROUTES},
    {path:'industries',children:INDUSTRIES_ROUTES},
    {path:'tech-blogs',children:BLOG_ROUTES},
    {path:'kalpita-case-studies',children:caseStudiesRoutes},
    {path:'kalpita-white-papers',children:whitepaper_routes},
    {path:'kalpita-tech-geek',children:techgeek_routes},
    {path:'kalpita-press-release',children:inthenews_routes},
    {path:'careers',children:Careers_Routes},
    {path:'gallery',children:GalleryPage_Routes},
    {path: 'aboutcompany/legal', children: LEGAL_ROUTES}
];